module.exports = __webpack_public_path__ + "assets/img/swiper-3-6.cfdf3134.jpg";